import React from 'react'

class ExternalRedirect extends React.Component {
  componentDidMount () {
    window.location.href = this.props.to
  }
  render () {
    return <div>Redirecting...</div>
  }
}
export default ExternalRedirect



// WEBPACK FOOTER //
// ./src/components/ExternalRedirect.js